import {
  http
} from '../config';
import base from './base';

export const trainingMaterials={
  getTrainingMaterialsList(data){
    return http({
      url:`${base.users}/tea/trainingMaterialsList`,
      method:'post',
      data
    });
  },
  getTrainingMaterialsDetails(id){
    return http({
      url:`${base.users}/tea/trainingMaterialDetails/${id}`,
      method:'get',
    });
  },
  viewStudentReport(data){
    return http({
      url:`${base.users}/tea/studyReport`,
      method:'post',
      data,
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/trainingMaterials.js